export default "__VITE_ASSET__cl2yykXh__"